import { S as Swiper } from './swiper-core-BHOuL--z.js';
import './utils-DWOYB00a.js';

class UpsellProductsSwiper extends HTMLElement {
  connectedCallback() {
    new Swiper(this, {
      slidesPerView: 2.2,
      spaceBetween: 4,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define('upsell-products-swiper', UpsellProductsSwiper);
